<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Member Details</div>
      </div>
      <div slot="action" v-if="!newMember">
        <v-tooltip top v-if="acctDisabled">
          <v-btn slot="activator" icon @click="doPromptToggleEnable" :loading="submitting">
            <v-icon color="red">mdi-lock</v-icon>
          </v-btn>
          <span>User account is disabled</span>
        </v-tooltip>
        <v-tooltip top v-else>
          <v-btn slot="activator" icon @click="doPromptToggleEnable" :loading="submitting">
            <v-icon color="green">mdi-lock-open</v-icon>
          </v-btn>
          <span>User account is not disabled</span>
        </v-tooltip>
        <v-tooltip top v-if="!newMember">
          <v-btn slot="activator" icon :loading="submitting" @click="promptResetPass = true">
            <v-icon color="orange">mdi-email-secure</v-icon>
          </v-btn>
          <span>Resend Reset Password Mail</span>
        </v-tooltip>
        <v-tooltip top v-if="!newMember">
          <v-btn slot="activator" icon :loading="submitting" @click="promptResetActive = true">
            <v-icon color="orange">mdi-contact-mail</v-icon>
          </v-btn>
          <span>Resend Activation Code Mail</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-card-title>
          <div class="body-2">Particular</div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs4>
            <v-select :items="salutationList" v-model="memberForm.salutation" :label="labels.salutation" item-text="label" item-value="value" data-vv-name="salutation" :data-vv-as="labels.salutation" :error-messages="errors.collect('salutation')" v-validate="'required'" @change="doSalutation"></v-select>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="memberForm.name" :label="labels.name" :error-messages="errors.collect('name')" data-vv-name="name" :data-vv-as="labels.name" v-validate="'required|max:60'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.nricPassport" :label="labels.nricPassport" :error-messages="errors.collect('nricPassport')" data-vv-name="nricPassport" :data-vv-as="labels.nricPassport" v-validate="'required|max:20'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <cal-picker :label="labels.dob" v-model="memberForm.dob" :error-messages="errors.collect('dob')" data-vv-name="dob" :data-vv-as="labels.dob" v-validate="'required'"></cal-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-radio-group v-model="memberForm.gender" row :label="labels.gender" :error-messages="errors.collect('gender')" data-vv-name="gender" :data-vv-as="labels.gender" v-validate="'required'">
              <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :items="memberGrpList" v-model="memberForm.groupId" :label="labels.groupId" item-text="label" item-value="value" data-vv-name="groupId" :data-vv-as="labels.groupId" :error-messages="errors.collect('groupId')" clearable></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!-- <v-flex xs6> AR: 28Jul2020 SR5359
            <v-checkbox v-model="memberForm.isStudent" :label="labels.isStudent" :error-messages="errors.collect('isStudent')" data-vv-name="isStudent" :data-vv-as="labels.isStudent" hide-details></v-checkbox>
          </v-flex> -->
          <v-flex xs12 v-if="newMember">
            <v-autocomplete :items="b2CKeyList" v-model="memberForm.b2cKey" :label="labels.b2cKey" item-text="label" item-value="value" data-vv-name="b2cKey" :data-vv-as="labels.b2cKey" :error-messages="errors.collect('b2cKey')"></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-card-title>
          <div class="body-2">Contact Information</div>
        </v-card-title>
        <div v-if="newMember">
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field v-model="memberForm.email" :label="labels.email" :error-messages="errors.collect('email')" data-vv-name="email" :data-vv-as="labels.email" v-validate="'required|email|max:128'" ></v-text-field>
            </v-flex>
            <!-- <v-flex xs6>
              <v-text-field id="password" type="password" v-model="memberForm.password" :label="labels.password" :error-messages="errors.collect('password')" data-vv-name="password" :data-vv-as="labels.password" v-validate="'required|min:8'" ref="password"></v-text-field>
            </v-flex> -->
            <v-flex xs6>
              <v-text-field v-model="memberForm.mobileNo" :label="labels.mobileNo" :error-messages="errors.collect('mobileNo')" data-vv-name="mobileNo" :data-vv-as="labels.mobileNo" v-validate="'required|min:8'"></v-text-field>
            </v-flex>
            <!-- <v-flex xs6>
              <v-text-field id="cfmPassword" type="password" v-model="memberForm.cfmPassword" :label="labels.cfmPassword" :error-messages="errors.collect('cfmPassword')" data-vv-name="cfmPassword" :data-vv-as="labels.cfmPassword" v-validate="'required|min:8|confirmed:password'" ref="cfmPassword"></v-text-field>
            </v-flex> -->
          </v-layout>
        </div>
        <v-layout row wrap v-else>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.email}}</v-subheader>
            <div class="title">{{memberForm.email}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.mobileNo}}</v-subheader>
            <div class="title">{{memberForm.mobileNo}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.telNo1" :label="labels.telNo1" :error-messages="errors.collect('telNo1')" data-vv-name="telNo1" :data-vv-as="labels.telNo1" v-validate="'max:20'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="memberForm.telNo2" :label="labels.telNo2" :error-messages="errors.collect('telNo2')" data-vv-name="telNo2" :data-vv-as="labels.telNo2" v-validate="'max:20'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-card-title>
          <div class="body-2">Residential Address</div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.add3" :label="labels.unitNo" :error-messages="errors.collect('add3')" data-vv-name="add3" :data-vv-as="labels.unitNo" v-validate="'max:30'" @input="copyAddress"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="memberForm.postalCode" :label="labels.postalCode" :error-messages="errors.collect('postalCode')" data-vv-name="postalCode" :data-vv-as="labels.postalCode" v-validate="'required|max:8'" @change="doMemberAddress" :lodaing="postCodeLoading" @input="copyAddress"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.add1" :label="labels.blockHouseNo" :error-messages="errors.collect('add1')" data-vv-name="add1" :data-vv-as="labels.blockHouseNo" v-validate="'required|max:30'" @input="copyAddress"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="memberForm.add2" :label="labels.streetName" :error-messages="errors.collect('add2')" data-vv-name="add2" :data-vv-as="labels.streetName" v-validate="'required|max:255'" @input="copyAddress"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.add4" :label="labels.buildingName" :error-messages="errors.collect('add4')" data-vv-name="add4" :data-vv-as="labels.buildingName" v-validate="'max:255'" @input="copyAddress"></v-text-field>
          </v-flex>
        </v-layout>
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-card-title>
          <div class="body-2">Mailing Address</div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12>
            <v-checkbox v-model="memberForm.mailAdd" :label="labels.sameAddress" :error-messages="errors.collect('mailAdd')" data-vv-name="mailAdd" :data-vv-as="labels.sameAddress" hide-details @change="doMailAddress"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.mailAdd3" :label="labels.unitNo" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.unitNo" :disabled="memberForm.mailAdd" v-validate="'max:30'" ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="memberForm.mailPostalCode" :label="labels.postalCodeOpt" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :data-vv-as="labels.postalCodeOpt" :disabled="memberForm.mailAdd" v-validate="'max:8'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.mailAdd1" :label="labels.blockHouseNoOpt" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.blockHouseNoOpt" :disabled="memberForm.mailAdd" v-validate="'max:30'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="memberForm.mailAdd2" :label="labels.streetNameOpt" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.streetNameOpt" :disabled="memberForm.mailAdd" v-validate="'max:255'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field v-model="memberForm.mailAdd4" :label="labels.buildingName" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.buildingName" :disabled="memberForm.mailAdd" v-validate="'max:255'"></v-text-field>
          </v-flex>
        </v-layout>
        <v-btn color="primary" :loading="submitting" dark class="mb-2" @click="doNewMember" v-if="newMember">
          Save Member Detail
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn color="primary" :loading="submitting" dark class="mb-2" @click="doUpdateMember" v-else>
          Update Member Detail
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-container>
    </v-card-text>
    <confirm v-model="promptDisable" :label="disabledLabel" @ok="doToggleEnableUser"></confirm>
    <confirm v-model="promptResetPass" title="Reset Forget Password Mail" label="Are you sure you want to reset this member's password? A Reset Password Mail will send to this email" @ok="doResetPassword"></confirm>
    <confirm v-model="promptResetActive" title="Resend Activation Mail" label="Are you sure you want to reset this member's password? A Activation Mail will send to this email" @ok="doResendActivatation"></confirm>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { salutation, gender } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      labels: {
        salutation: 'Salutation*',
        name: 'Name as in NRIC/Passport*',
        nricPassport: 'NRIC/Passport*',
        dob: 'Date of Birth*',
        gender: 'Gender*',
        isStudent: 'Are you a full time student?',
        mobileNo: 'Mobile No.*',
        email: 'Email*',
        password: 'Password*',
        cfmPassword: 'Confirm Password*',
        telNo1: 'Home No.',
        telNo2: 'Office No.',
        unitNo: 'Unit No.', // add3
        postalCode: 'Postal Code*',
        blockHouseNo: 'Block/House No*', // add1
        streetName: 'Street Name*', // add2
        postalCodeOpt: 'Postal Code',
        blockHouseNoOpt: 'Block/House No',
        streetNameOpt: 'Street Name',
        buildingName: 'Building Name', // add4
        sameAddress: 'Same as Residential Address',
        groupId: 'Member Group',
        b2cKey: 'Verification Code Link*'
      },
      memberForm: {
        salutation: null,
        name: null,
        nricPassport: null,
        dob: null,
        gender: null,
        isStudent: null,
        email: null,
        mobileNo: null,
        telNo1: null,
        telNo2: null,
        postalCode: null,
        add1: null,
        add2: null,
        add3: null,
        add4: null,
        mailAdd: null,
        mailPostalCode: null,
        mailAdd1: null,
        mailAdd2: null,
        mailAdd3: null,
        mailAdd4: null,
        password: null,
        cfmPassword: null,
        groupId: null,
        b2cKey: null
      },
      acctDisabled: undefined,
      newMember: false,
      submitting: false,
      postCodeLoading: false,
      memberGrpList: [],
      promptDisable: false,
      promptResetPass: false,
      promptResetActive: false,
      disabledLabel: '',
      interMenu: [],
      b2CKeyList: []
    }
  },
  mounted() {
    Promise.all([this.doMemberGroup(), this.doB2CKeys()])
    if (this.id === 'new') {
      this.newMember = true
    } else {
      this.newMember = false
      this.doFetch()
    }
  },
  methods: {
    async doFetch() {
      const apiURI = this.menu.memberGet
      if (apiURI) {
        try {
          const expand = {
            id: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            const data = result.data
            this.memberForm.salutation = data.salutation
            this.memberForm.name = data.name
            this.memberForm.nricPassport = data.nricPassport
            this.memberForm.dob = data.dob
            this.memberForm.gender = data.gender
            this.memberForm.isStudent = data.isStudent
            this.memberForm.email = data.email
            this.memberForm.mobileNo = data.mobileNo
            this.memberForm.telNo1 = data.telNo1
            this.memberForm.telNo2 = data.telNo2
            this.memberForm.postalCode = data.postalCode
            this.memberForm.add1 = data.add1
            this.memberForm.add2 = data.add2
            this.memberForm.add3 = data.add3
            this.memberForm.add4 = data.add4
            this.memberForm.mailAdd = data.mailAdd
            this.memberForm.mailPostalCode = data.mailPostalCode
            this.memberForm.mailAdd1 = data.mailAdd1
            this.memberForm.mailAdd2 = data.mailAdd2
            this.memberForm.mailAdd3 = data.mailAdd3
            this.memberForm.mailAdd4 = data.mailAdd4
            if (typeof data.groupName === 'undefined') {
              this.memberForm.groupId = null
            } else {
              this.memberForm.groupId = this.memberGrpList.find(item => item.label === data.groupName)
            }
            this.acctDisabled = data.acctDisabled
            this.interMenu = extractMenu(result.data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.message('Invalid API URL')
      }
    },
    async doNewMember() {
      this.submitting = true
      this.resetMessages()
      const result = await this.$validator.validateAll()
      if (result) {
        const apiURI = this.menu.memberCreate
        if (apiURI) {
          try {
            const result = await this.$http.post(apiURI, this.memberForm)
            const data = result.data
            if (data) {
              this.notify(data)
              this.$router.push({ name: 'membersList' })
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.promptFieldCheck()
      }
      this.submitting = false
    },
    async doUpdateMember() {
      this.submitting = true
      this.resetMessages()
      const result = await this.$validator.validateAll()
      if (result) {
        const apiURI = this.menu.memberUpdate
        if (apiURI) {
          try {
            const expand = {
              usrId: this.id
            }
            const result = await this.$http.put(expandURI(apiURI, expand), this.memberForm)
            const data = result.data
            if (data) {
              this.notify(data)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.promptFieldCheck()
      }
      this.submitting = false
    },
    doMailAddress() {
      if (this.memberForm.mailAdd) {
        this.memberForm.mailPostalCode = this.memberForm.postalCode
        this.memberForm.mailAdd1 = this.memberForm.add1
        this.memberForm.mailAdd2 = this.memberForm.add2
        this.memberForm.mailAdd3 = this.memberForm.add3
        this.memberForm.mailAdd4 = this.memberForm.add4
      }
    },
    async doMemberAddress() {
      if (this.memberForm.postalCode) {
        const apiUrl = this.menu.address
        if (apiUrl) {
          try {
            this.postCodeLoading = true
            const expand = {
              postCode: this.memberForm.postalCode
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result
            if (data) {
              this.memberForm.add1 = data.add1
              this.memberForm.add2 = data.add2
              this.memberForm.add4 = data.add4
            }
            this.postCodeLoading = false
          } catch (err) {
            this.postCodeLoading = false
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      }
    },
    copyAddress() {
      if (this.memberForm.mailAdd) {
        this.memberForm.mailPostalCode = this.memberForm.postalCode
        this.memberForm.mailAdd1 = this.memberForm.add1
        this.memberForm.mailAdd2 = this.memberForm.add2
        this.memberForm.mailAdd3 = this.memberForm.add3
        this.memberForm.mailAdd4 = this.memberForm.add4
      }
    },
    doSalutation() {
      if (this.memberForm.salutation === 'MR') {
        this.memberForm.gender = 'M'
      } else if (this.memberForm.salutation === 'MS' || this.memberForm.salutation === 'MDM' || this.memberForm.salutation === 'MRS') {
        this.memberForm.gender = 'F'
      } else {
        if (!this.memberForm.gender || this.memberForm.gender === null) {
          this.memberForm.gender = 'M'
        }
      }
    },
    async doMemberGroup() {
      const apiURI = this.menu.memberGroups
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.memberGrpList = []
          if (data) {
            data.map((memberGroup) => {
              const convertMemberGroup = {
                value: memberGroup.groupId,
                label: memberGroup.groupDesc
              }
              this.memberGrpList.push(convertMemberGroup)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doB2CKeys() {
      const apiURI = this.menu.b2cKeys
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.b2CKeyList = []
          if (data) {
            this.b2CKeyList = data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doPromptUnblock() {
      this.promptUnblock = true
    },
    doPromptToggleEnable() {
      if (this.acctDisabled) {
        this.disabledLabel = 'Do you want to enable this user?'
      } else {
        this.disabledLabel = 'Do you want to disable this user?'
      }
      this.promptDisable = true
    },
    async doToggleEnableUser() {
      let apiURI
      if (this.acctDisabled) {
        apiURI = this.menu.enable
      } else {
        apiURI = this.menu.disable
      }
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            this.acctDisabled = !this.acctDisabled
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doResetPassword() {
      const apiURI = this.interMenu.memberResetPasswordMail
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doResendActivatation() {
      const apiURI = this.interMenu.memberResendActivationMail
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  computed: {
    genderList() {
      let result = []
      Object.keys(gender).forEach(function(key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function(key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    menu() {
      return this.$store.state.adminMember.menu
    }
  },
  props: ['id'],
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
